import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f1f28000&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f1f28000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f28000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f28000')) {
      api.createRecord('f1f28000', component.options)
    } else {
      api.reload('f1f28000', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f1f28000&scoped=true&", function () {
      api.rerender('f1f28000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ze5sY6jLHenO/JS/comp/GuestBox.vue"
export default component.exports